import Vue from 'vue'
import VueRouter from 'vue-router'
import AppointmentView from '../views/AppointmentView.vue'
import AppointmentDetailView from '../views/AppointmentDetailView.vue'
import RatingView from '../views/rating.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import Errors from '../views/404.vue'
import CancelReservation from '../views/cancelReservation.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: AppointmentView
  },
  {
    path: '/detail',
    name: 'appointmentDetail',
    component: AppointmentDetailView
  },
  {
    path: '/rating',
    name: 'rating',
    component: RatingView
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPolicy
  },
  {
    path: '/cancel',
    name: 'cancel',
    component: CancelReservation
  },
  {
    path: '*',
    name: '404',
    component: Errors
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
